import {
  Button,
  Tab,
  Tabs,
  Icon,
  Popup,
  NavBar,
  Image as VanImage,
  Empty,
  Overlay,
  Swipe,
  SwipeItem,
  CountDown,
  Sticky,
  Toast,
  Cell,
  CellGroup,
  PasswordInput ,
  NumberKeyboard,
  Skeleton,
  Checkbox, 
  
  CheckboxGroup
} from 'vant';
/**
 * 引入需要的组件注册，按需引入减小包体积
 */
var components = [
  Button, Tab, Tabs, Icon, Popup, NavBar, VanImage, Empty, Overlay, Swipe, SwipeItem, CountDown, Sticky, Toast,
  Cell,CellGroup,PasswordInput,NumberKeyboard,Skeleton,Checkbox, CheckboxGroup
];

export default {
  install: (vue) => {
    components.forEach(component => {
      vue.component(component.name, component);
    });
  }
};
